import { Avatar } from "@mui/material";

function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}
function stringAvatar(name) {
    return {
        sx: {
            width: 120,
            height: 120
        },
        //children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
}

function Testimonial(props) {
    const customerComment = props.customerComment;
    const customerName = props.customerName;
    const customerImage = props.customerImage;
    return (
        <div className="relative">
            <Avatar src={customerImage} {...stringAvatar(customerName)} className="absolute top-[50px] mx-auto" />
            <div className="bg-white bg-opacity-20 rounded-xl px-8 py-12 pt-16 md:px-16 md:pb-8">
                <p className="poppins text-lg md:text-lg mb-4 text-center poppins">{customerComment}</p>
                <p className="poppins font-semibold text-2xl text-center eb-garamond">{customerName}</p>
                <div className="mt-2">
                    <div className="text-center mx-auto w-auto py-4 text-2xl">
                        <i className="fas fa-star text-white"></i>
                        <i className="fas fa-star text-white"></i>
                        <i className="fas fa-star text-white"></i>
                        <i className="fas fa-star text-white"></i>
                        <i className="fas fa-star text-white"></i>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Testimonial;